// @flow
import * as React from 'react';
import cx from 'classnames';

import images from './images/images';
import t from '../locale';
import cs from './styles.pcss';
import ArrowButton from './arrowButton';
import useWindowDimensions from '../../utils/use-window-dimensions';

const USERS = ['Cool_Trend_4You', 'tottiothug', 'w5556-4'];

const generateDataObject = () =>
  USERS.map((name) => ({
    id: name,
    userName: name,
    userFrom: `${t(`reviews.${name}.status.first`)} ${t(
      `reviews.${name}.status.second`
    )}`,
    reviewTitle: t(`reviews.${name}.title`),
    reviewText: t(`reviews.${name}.text`),
    icons: images[`${name}`],
    link: t(`reviews.${name}.link`),
  }));

export default function Slider(): React.Node {
  const { width } = useWindowDimensions();
  const [slideIndex, setSlideIndex] = React.useState(1);
  const [blockHeight, setBlockHeight] = React.useState('590px');
  const data = generateDataObject();

  const nextSlide = () => {
    if (slideIndex !== data?.length) {
      setSlideIndex(slideIndex + 1);
    } else if (slideIndex === data?.length) {
      setSlideIndex(1);
    }
  };

  const prevSlide = () => {
    if (slideIndex !== 1) {
      setSlideIndex(slideIndex - 1);
    } else if (slideIndex === 1) {
      setSlideIndex(data?.length);
    }
  };

  const moveDot = (index) => {
    setSlideIndex(index);
  };

  React.useEffect(() => {
    if (width) {
      setBlockHeight(`${0.001 * width * width - 1.6 * width + 925}px`);
    }
  }, [width]);

  return (
    <div className={cs.slider}>
      <div
        className={cs.container}
        style={{ height: `${blockHeight}`, maxHeight: '530px' }}
      >
        {data.map((obj, index) => (
          <div
            key={obj.id}
            className={cx(cs.slide, {
              [cs.slideActive]: slideIndex === index + 1,
            })}
          >
            <div className={cs.reviewTexts}>
              <p className={cs.reviewTitle}>&quot;{obj?.reviewTitle}</p>
              <p className={cs.reviewMessage}>{obj?.reviewText}&quot;</p>
            </div>
            <div className={cs.reviewCaption}>
              <picture className={cx(cs.usrAvatar, cs.usrPicture)}>
                <source
                  srcSet={`${obj?.icons['1xWebP']} 1x, ${obj?.icons['2xWebP']} 2x`}
                  type="image/webp"
                />
                <img
                  alt="User avatar"
                  src={obj?.icons['1x']}
                  srcSet={`${obj?.icons['1x']} 1x, ${obj?.icons['2x']} 2x`}
                  loading="lazy"
                  className={cs.usrAvatar}
                />
              </picture>
              <div className={cs.reviewCaptionText}>
                <span className={cs.userName}>{obj?.userName}</span>
                <span className={cs.userFrom}>
                  {' | '}
                  {obj?.userFrom}
                </span>
              </div>
            </div>
          </div>
        ))}

        <ArrowButton moveSlide={nextSlide} direction="next" />
        <ArrowButton moveSlide={prevSlide} direction="prev" />
      </div>

      <div className={cs.dots}>
        {Array.from({ length: data?.length }).map((item, index) => (
          <button
            // eslint-disable-next-line
            key={index}
            type="button"
            onClick={() => {
              moveDot(index + 1);
            }}
            className={cx(cs.dot, {
              [cs.dotActive]: slideIndex === index + 1,
            })}
          >
            <span className={cs.dotText}>control dot</span>
          </button>
        ))}
      </div>
    </div>
  );
}
